export default __webpack_public_path__ + "static/bao-fdcc1e5d52f824c60daefeac256d5993.png";